<template>
  <div class="m-10">
    <button v-if="!externalNavigation"
        @click="showHowTo = true"
        class="bg-indigo-600 hover:bg-indigo-700 text-white font-medium px-6 py-3 rounded-lg shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-150 border border-indigo-500 hover:border-indigo-400"
      >
        How-To RateLimit
      </button>

    <HowToGuide
      v-if="isGuideVisible"
      :pages="rateLimitGuidePages"
      :initial-page="0"
      @close="handleClose"
      @complete="handleGuideComplete"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import { ref, computed } from "vue";
import HowToGuide from "@/components/HowToGuide.vue";


import organisationImage from "@/assets/howto/ratelimit/organisation.png";
import rateLimitImage from "@/assets/howto/ratelimit/ratelimit.png";
import rateLimitAddOrgButtonImage from "@/assets/howto/ratelimit/ratelimit-add-org-button.png";
import rateLimitFormImage from "@/assets/howto/ratelimit/ratelimit-form.png";
import rateLimitOrgImage from "@/assets/howto/ratelimit/ratelimit-org.png";
import rateLimitOrgFormImage from "@/assets/howto/ratelimit/ratelimit-org-form.png";
import rateLimitAddImage from "@/assets/howto/ratelimit/ratelimit-add.png";


export default {
  name: "ParentComponent",
  components: {
    HowToGuide,
  },
  
  props: {
    showHowToPage: {
      type: Boolean,
    },
    externalNavigation: {
      type: Boolean,
    }
  },

  emits: ["showHowToClose"],
  setup(props, { emit }) {
    const showHowTo = ref(false);

    const isGuideVisible = computed(() => {
      return props.externalNavigation ? props.showHowToPage : showHowTo.value;
    }); 

    const rateLimitGuidePages = ref([
        {
            heading: "Navigate to Rate Limit Configurations",
            upperText: [
                "From the main navigation menu, click on \"Workspace\".",
                "Select \"Rate Limit Configurations\" from the submenu.",
                "You'll see the Rate Limit Overview page showing all existing Rate Limits."
            ],
            image: rateLimitImage,
            imageAlt: "Rate Limit navigation screenshot",
            lowerText: []
        },
        {
            heading: "Initiate Organisation Creation",
            upperText: [
                "Click on the \"Organisations\" button.",
                "This will redirect you to the Workspace Organisation overview page.",
                "Click on the \"Add Organisation\" button."
            ],
            image: rateLimitAddOrgButtonImage,
            imageAlt: "Organisation creation navigation",
            lowerText: []
        },
        {
            heading: "Initiate Organisation Creation",
            upperText: [
                "This will open the \"Add Organisation\" form.",
                
            ],
            image: rateLimitOrgFormImage,
            imageAlt: "Organisation creation navigation",
            lowerText: [
              "In the \"Name\" field specify the name of the new organisation.",
              "In the \"Organisation Key\" specify a unique key e.g OrgName-Key.",
              "Click the \"Create Organisation\" button to complete the process."
            ]
        },
        {
            heading: "Initiate the Rate Limit Creation",
            upperText: [
                "Click on the \"Add Rate Limit\" button.",
            ],
            image: rateLimitAddImage,
            imageAlt: "Rate Limit creation form",
            lowerText: [
              "The \"Add Rate Limit\" form will appear.",
            ]
        },
        {
            heading: "Initiate the Rate Limit Creation",
            upperText: [
                "Select the \"Organisation\" from the organisation drop down list that the ratelimit should apply to."
            ],
            image: rateLimitFormImage,
            imageAlt: "Rate Limit creation form",
            lowerText: [
                "In the \"Max Concurrent Updates\" field input the maximum number of machines 'computers' that can update at a time.",
                "Click the \"Create Rate Limit\" button."
            ]
        }
    ]);

    const handleGuideComplete = () => {
      showHowTo.value = false;
      emit("showHowToClose", false);
    };

    const handlePageChange = (pageIndex) => {
      console.log(`User navigated to page ${pageIndex + 1}`);
    };

    const handleClose = () => {
      if (props.externalNavigation){
        emit("showHowToClose", false);
      } else {
        showHowTo.value = false;
      }
    }

    return {
      showHowTo,
      rateLimitGuidePages,
      handleGuideComplete,
      handlePageChange,
      handleClose,
      isGuideVisible
    };
  }
};
</script>